import styled from 'styled-components';
import { height, width, margin } from 'styled-system';
import { spacePropsArray } from '../utils/styled-components/propArrays';
import { SvgIconProps } from './IconProps';

export const BaseSvgIcon: React.FC<SvgIconProps> = styled.svg
    .withConfig({
        shouldForwardProp: (prop, defaultValidatorFn) => {
            return (
                !['width', 'height', 'transitionsOn', 'rotation', ...spacePropsArray].includes(prop) &&
                defaultValidatorFn(prop)
            );
        },
    })
    .attrs(() => ({
        version: '1.1',
        xmlns: 'http://www.w3.org/2000/svg',
        xmlnsXlink: 'http://www.w3.org/1999/xlink',
    }))<SvgIconProps>`
    ${({ rotation }) => rotation !== 0 && `transform: rotate(${rotation}deg);`}
    ${({ transitionsOn }) => transitionsOn && `transition: all 0.2s;`}
    ${width}
    ${height}
    ${margin}
`;

BaseSvgIcon.defaultProps = {
    transitionsOn: false,
    rotation: 0,
};
